import React, { useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import Textarea from '../Form/Fields/Textarea';
import Select from '../Form/Fields/Select';
import Button from '../Form/Button';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

const TYPE_OPTIONS = [
    { value: 'BUG', label: 'Bug' },
    { value: 'EVOLUTION', label: 'Évolution' },
    { value: 'GENERAL', label: 'Général' },
    { value: 'AUTRE', label: 'Autre' },
];

export default function ContactModal({ show, onClose }) {
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (data) => {
        setIsLoading(true);
        axios.post(`${API_BASE_URL}/api/v1/support/contact`, data, { withCredentials: true })
            .then(() => {
                toast.success('Votre message a été envoyé. Notre équipe vous répondra rapidement.');
                onClose();
            })
            .catch(() => toast.error('Une erreur est survenue. Veuillez réessayer.'))
            .finally(() => setIsLoading(false));
    };

    return (
        <Modal
            id="contactModal"
            title="Nous contacter"
            show={show}
            onClose={onClose}
            icon={faEnvelope}
            iconBg="#e0e7ff"
            iconColor="#4338ca"
            footer={
                <Button isLoading={isLoading} loadingMessage="Envoi ..." type="submit" form="contactForm" className="modal-btn-primary">
                    Envoyer
                </Button>
            }
        >
            <Form id="contactForm" onSubmit={onSubmit} defaultValues={{ type: 'BUG', subject: '', message: '' }} key={show}>
                <div className="mb-3">
                    <label className="cdm-field-label">Type de la demande <span className="text-danger">*</span></label>
                    <Select name="type" options={TYPE_OPTIONS} />
                </div>
                <div className="mb-3">
                    <label className="cdm-field-label">Sujet <span className="text-danger">*</span></label>
                    <InputText
                        name="subject"
                        placeholder="ex: Problème avec une vente"
                        validationRules={{ required: 'Le sujet est requis' }}
                    />
                </div>
                <div className="mb-3">
                    <label className="cdm-field-label">Message <span className="text-danger">*</span></label>
                    <Textarea
                        name="message"
                        placeholder="Décrivez votre problème ou votre question..."
                        validationRules={{ required: 'Le message est requis' }}
                    />
                </div>
            </Form>
        </Modal>
    );
}
